import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import CategoryGrid from './components/CategoryGrid';
import WhySection from './components/WhySection';
import TrustSection from './components/TrustSection';
import SeoPreviewSection from './components/SeoPreviewSection';
import CtaFullSection from './components/CtaFullSection';

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Yoybuy Finds",
  "url": "https://yoybuyfinds.lat",
  "description": "Yoybuy Sheet — полное руководство по поиску дешёвых товаров из Китая. Экономьте до 70% с проверенными spreadsheet-таблицами на kaspreadsheet.com.",
  "inLanguage": "ru",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://kaspreadsheet.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <StatsBar />
        <CategoryGrid />
        <WhySection />
        <TrustSection />
        <SeoPreviewSection />
        <CtaFullSection />
      </main>
      <Footer />
    </>
  );
}